import { render, staticRenderFns } from "./AppCadastro.vue?vue&type=template&id=62c120ec&"
import script from "./AppCadastro.vue?vue&type=script&lang=js&"
export * from "./AppCadastro.vue?vue&type=script&lang=js&"
import style0 from "./AppCadastro.vue?vue&type=style&index=0&id=62c120ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports